import { Link } from '@inertiajs/inertia-react'
import useLazyLoad from 'app/components/hooks/useLazyLoad'
import Icon from 'app/components/Icon'
import Layout from 'app/components/Layouts/Layout'
import { MODALS, ModalsContext } from 'app/components/Layouts/Modals'
import { TaskType } from 'app/components/Types/TaskType'
import IconText from 'app/fragments/IconText'
import { LineButton } from 'app/fragments/LineButton'
import { TaskCard } from 'app/fragments/TaskCard'
import { UserAvatar } from 'app/fragments/UserAvatar'
import moment, { duration } from 'moment'
import React, { useContext } from 'react'
import route from 'ziggy-js'

interface Props {
    project
}

function Detail(props: Props) {
    const { project } = props

    const { open } = useContext(ModalsContext)
    const [tasks, button, meta, form, setTask] = useLazyLoad<TaskType>('tasks');

    let estimate = duration(project.estimate);
    let u_estimate = duration(project.upper_estimate);

    return (
        <Layout heading='Project'>
            <div className='flex items-center justify-between'>
                <div className='mt-40px mb-24px'>
                    <Link href={route('tasks.index')} className="bg-gray-1C1C1C rounded-full w-55px h-55px flex items-center justify-center text-white"><Icon className='rotate-180' name="arrow-right" /></Link>
                </div>
                <a className="cursor-pointer nMob:hidden" onClick={() => open(MODALS.NEWTASK, false, {project: project})}><IconText className="bg-green-539648 hover:bg-green-539648/70 text-white py-12px px-16px rounded-full text-16 font-medium" icon="plus" text="Add Task" /></a>   
                    
            </div>
            <div className='flex justify-between'>
                <h2 className='text-24 font-bold'>{project.name}</h2>
                <div className='flex items-center gap-16px'>
                    <a className="cursor-pointer mob:hidden" onClick={() => open(MODALS.NEWTASK, false, {project: project})}><IconText className="bg-green-539648 hover:bg-green-539648/70 text-white py-12px px-16px rounded-full text-16 font-medium" icon="plus" text="Add Task" /></a>   
                    <div className="flex gap-8px items-center">
                        <Icon name="target" />
                        <div className="text-14">{moment(project.deadline, 'D. M. YYYY H:i').format('D. M. YYYY')}</div>
                    </div>
                </div>
            </div>
            <div className='flex justify-between mt-16px'>
                <div className="flex gap-16px mt-10px items-center">
                    {/* <div className="bg-gray-343434 p-8px text-white font-medium rounded-full text-12">{task.project.name}</div> */}
                    <div className="flex">
                        {
                            project?.users?.slice(0, 3).map(u =>
                                <UserAvatar user={u} />
                            )
                        }
                        {
                            (project?.users?.length > 3) &&
                            <div className="rounded-full h-32px w-32px border-2 border-gray-1C1C1C bg-gray-343434 -mx-4px flex items-center justify-center overflow-hidden"
                                title={project?.users?.slice(3).reduce((p, c, i) => `${p}${i > 0 ? ', ' : ''}${c.name}`, '')}
                            >
                                +{project.users.length - 3}
                            </div>
                        }
                    </div>
                    <a className="cursor-pointer" onClick={() => open(MODALS.EDITPROJECT, false, { project: project })}><IconText className="bg-green-539648 text-white py-12px px-16px rounded-full text-16 font-medium" icon="plus" text="Edit" /></a>
                </div>
                <div className='flex items-center'>
                    <div className="flex gap-8px items-center">
                        <div className="text-14">{`${(Math.floor(estimate.asHours()))}h ${(estimate.minutes())}m`} <span className=" text-white/50">/ {`${(Math.floor(u_estimate.asHours()))}h ${(u_estimate.minutes())}m`}</span></div>
                    </div>
                </div>
            </div>
            {/* <div>
                <h3 className='text-18 font-semibold mt-45px mb-16px'>Popis</h3>
                <div className='text-16 font-medium leading-6'>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Placeat ad ipsum maxime, doloribus minus rem veritatis, dolor repellat laborum recusandae excepturi porro ratione error architecto voluptate? Unde, at quas. Vitae!</div>
            </div> */}
            <div className="grid grid-cols-3 gap-30px py-60px mob:grid-cols-1">
                {/* <div onClick={(e) => { e.preventDefault(); open(MODALS.NEWTASK) }} className="fixed top-1/2 cursor-pointer right-50px w-50px h-50px bg-blue-700 rounded-full flex items-center justify-center">
                    <Icon className={"transform rotate-45 w-16px"} name="cross" />
                </div> */}

                {
                    tasks.map(t =>
                        <TaskCard t={t} />
                    )
                }
            </div>
            {button && <LineButton {...button} text={"Nacist dalsi"} href={"#"} />}
            {
                meta &&
                <div className="flex justify-center my-20px">
                    <div className="text-white text-16">Zobrazuji {meta.to} z {meta.total}</div>
                </div>
            }
        </Layout>
    )
}

export default Detail
